/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Custom slider navigation for index-products
  document.addEventListener('DOMContentLoaded', function() {
    const customArrows = document.querySelectorAll('.custom-slider-arrows');
    
    customArrows.forEach(function(arrowContainer) {
      const gridSlider = arrowContainer.closest('grid-slider');
      const slider = gridSlider?.querySelector('[data-grid-slider]');
      const prevBtn = arrowContainer.querySelector('[data-custom-prev]');
      const nextBtn = arrowContainer.querySelector('[data-custom-next]');
      
      if (!slider || !prevBtn || !nextBtn) return;
      
      // Function to get all slides
      function getAllSlides() {
        return slider.querySelectorAll('[data-grid-item]');
      }
      
      // Function to get the first visible slide
      function getFirstVisibleSlide() {
        const slides = getAllSlides();
        const sliderRect = slider.getBoundingClientRect();
        
        for (let i = 0; i < slides.length; i++) {
          const slideRect = slides[i].getBoundingClientRect();
          // Check if slide is at least partially visible
          if (slideRect.right > sliderRect.left && slideRect.left < sliderRect.right) {
            return slides[i];
          }
        }
        return slides[0]; // fallback to first slide
      }
      
      // Function to update button states based on scroll position
      function updateButtonStates() {
        const slides = getAllSlides();
        const firstSlide = slides[0];
        const lastSlide = slides[slides.length - 1];
        
        // Get current scroll position
        const scrollLeft = slider.scrollLeft;
        const sliderWidth = slider.clientWidth;
        const totalWidth = slider.scrollWidth;
        
        // Check if we're at the beginning
        const isAtStart = scrollLeft <= 10; // small tolerance for rounding
        
        // Check if we're at the end
        const isAtEnd = scrollLeft >= (totalWidth - sliderWidth - 10); // small tolerance
        
        prevBtn.disabled = isAtStart;
        nextBtn.disabled = isAtEnd;
      }
      
      // Function to calculate slide width including gap
      function getSlideWidth() {
        const slides = getAllSlides();
        if (slides.length === 0) return 0;
        
        const firstSlide = slides[0];
        const secondSlide = slides[1];
        
        if (secondSlide) {
          // Calculate width including gap between slides
          return secondSlide.offsetLeft - firstSlide.offsetLeft;
        } else {
          // If only one slide, return its width
          return firstSlide.offsetWidth;
        }
      }
      
      // Function to scroll to next product
      function scrollToNext() {
        const slideWidth = getSlideWidth();
        const currentScrollLeft = slider.scrollLeft;
        
        // Calculate the next scroll position (one slide width to the right)
        const nextScrollLeft = currentScrollLeft + slideWidth;
        
        // Check if we can scroll further
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        
        // Allow scrolling to the maximum position, even if it means the last slide isn't fully visible
        const targetScrollLeft = Math.min(nextScrollLeft, maxScrollLeft);
        
        if (targetScrollLeft > currentScrollLeft) {
          slider.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
          });
        }
      }
      
      // Function to scroll to previous product
      function scrollToPrev() {
        const slideWidth = getSlideWidth();
        const currentScrollLeft = slider.scrollLeft;
        
        // Calculate the previous scroll position (one slide width to the left)
        const prevScrollLeft = currentScrollLeft - slideWidth;
        
        // Allow scrolling to the minimum position (0), ensuring we can reach the first slide
        const targetScrollLeft = Math.max(prevScrollLeft, 0);
        
        if (targetScrollLeft < currentScrollLeft) {
          slider.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
          });
        }
      }
      
      // Event listeners
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        scrollToNext();
      });
      
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        scrollToPrev();
      });
      
      // Update button states on scroll
      slider.addEventListener('scroll', updateButtonStates);
      
      // Initial button state update
      updateButtonStates();
      
      // Update on resize
      window.addEventListener('resize', function() {
        setTimeout(updateButtonStates, 100);
      });
    });
  });  


  function initRebuyCart() {
    document.addEventListener("rebuy:smartcart.ready", (e) => {
      const cart = e.detail.smartcart.cart;
      showPaymentIcons();
      showEstimatedDelivery();
      freeShippingHandle(cart);
    });
  
    document.addEventListener("rebuy:cart.change", (e) => {
      const cart = e.detail.cart.cart;
      showPaymentIcons();
      showEstimatedDelivery();
      freeShippingHandle(cart);
    });
  }
  
  function showPaymentIcons() {
    setTimeout(() => {
      const paymentIcons = document.querySelector(".cart__drawer__payment__icons");
      const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
  
      if (!paymentIcons || !checkoutArea || checkoutArea.querySelector(".cloned-payment-icons")) {
        return;
      }
  
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      clonedPaymentIcons.classList.add("cloned-payment-icons"); 
      checkoutArea.appendChild(clonedPaymentIcons);
    }, 500);
  }

  function showEstimatedDelivery() {
    setTimeout(() => {
      const estimatedDelivery = document.querySelector(".cart__drawer__estimated__delivery");
      const checkoutArea = document.querySelector('div[data-rebuy-component="cart-subtotal"]');
  
      if (!estimatedDelivery || !checkoutArea || checkoutArea.querySelector(".cloned-estimated-delivery")) {
        return;
      }

      const clonedEstimatedDelivery = estimatedDelivery.cloneNode(true);
      clonedEstimatedDelivery.classList.add("cloned-estimated-delivery");
      // Use prepend() to insert at the top instead of appendChild() which adds at the bottom
      checkoutArea.prepend(clonedEstimatedDelivery);
    }, 500);
  }


  function freeShippingHandle(cart) {
    setTimeout(() => {
      const cartFooter = document.querySelector(
        'div[data-rebuy-cart-anchor="footer"]'
      );
      const subtotalElement = cartFooter?.querySelector(
        'div[data-rebuy-component="cart-subtotal"]'
      );
      const currency = Shopify.currency.active;
      

      if (!cartFooter || !subtotalElement) {
        return;
      }

      const existingShipping = cartFooter.querySelector(".free-delivery-message");
      if (existingShipping) {
        existingShipping.remove();
      }

      const freeDeliveryMessage = document.createElement("div");
      freeDeliveryMessage.classList.add("free-delivery-message");

      const shippingText = document.createElement("span");
      shippingText.textContent = window.theme?.strings?.freeShippingLimitText;

      const shippingValue = document.createElement("span");

      const subtotalPrice = cart.items_subtotal_price;
      const freeShippingLimit = window.theme?.strings?.freeShippingLimit;
      const shippingCost = window.theme?.strings?.shippingCost;

      if (!freeShippingLimit || !shippingCost) {
        return;
      }

      let deliveryPrice = typeof shippingCost === 'string' 
        ? Number(shippingCost.replace(",", ".")) * 100
        : Number(shippingCost) * 100;
      const deliveryLimit = typeof freeShippingLimit === 'string'
        ? Number(freeShippingLimit.replace(",", ".")) * 100
        : Number(freeShippingLimit) * 100;

      if (isNaN(deliveryPrice) || isNaN(deliveryLimit)) {
        return;
      }

      shippingValue.textContent =
        subtotalPrice >= deliveryLimit
          ? window.theme?.strings?.shippingCostFree || "Free"
          : `$${(deliveryPrice / 100).toFixed(2)}`;

      freeDeliveryMessage.appendChild(shippingText);
      freeDeliveryMessage.appendChild(shippingValue);
      cartFooter.insertBefore(freeDeliveryMessage, subtotalElement);
    }, 500);
  }
  
  initRebuyCart();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
